import type { ThemeName } from "@huub-web/ui";
import { createContext } from "react";

interface AppSettingsState {
  theme: ThemeName;
  setTheme: (theme: ThemeName) => void;

  isVisualDebugEnabled: boolean;
  toggleVisualDebug: () => void;

  isAudioEnabled: boolean;
  toggleAudio: () => void;
  disableAudio: () => void;

  isResponseFeedbackEnabled: boolean;
  setIsResponseFeedbackEnabled: (enabled: boolean) => void;
}

export const AppSettingsContext = createContext<AppSettingsState | null>(null);
